import { useState, useEffect } from 'react';
import axios from 'axios';
import { HMA } from './HMA';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PageInfo } from '../common/PageInfo';
import { ImageInfo } from "../common/ImageInfo";

export function HMAs({ location }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [selectedItemData, setSelectedItemData] = useState(location.state ? location.state.selectedItemData : []);

  useEffect(() => {
    console.log('component mounted!');
    const retrieveData = async () => {
      try {
        await axios.get(`/image/publishedhmas`)
          .then((response) => {
            let array = [];
            if (response.data.length > 0) {
              for (let i = 0; i < response.data.length; i++) {
                array.push(response.data[i]);
              }
            } else {
              array.push({
                id: 1,
                filePath: "/images/HorseSilhouette.jpg",
                filePathThumb: "/images/HorseSilhouette.jpg",
                altText: "Horse Silhouette",
                imageText: "",
                title: "Unconfigured HMA",
                descriptionHTML: "<p>Unconfigured HMA Descriptive Text</p>"
              });
            }
            setData(array);
            setIsLoading(false);
          });
      } catch (e) {
        setError(e.message);
        setIsLoading(false);
      }
    }
    retrieveData();
  }, [])

  const onSelect = (event) => {
    let selectedItemDataCopy = [...selectedItemData];
    if (event.currentTarget.innerText === 'Selected!') {
      selectedItemDataCopy = selectedItemData.filter(function (x) { return x.id.toString() !== event.currentTarget.id; });
      setSelectedItemData(selectedItemDataCopy);
    } else {
      let item = data.find(x => x.id.toString() === event.currentTarget.id);

      if (item.isHmaMultiSelect) {
        selectedItemDataCopy = selectedItemDataCopy.filter(function (x) { return x.isHmaMultiSelect; });
      } else {
        selectedItemDataCopy = [];
      }

      selectedItemDataCopy.push(item);
      setSelectedItemData(selectedItemDataCopy);
    }
    event.preventDefault();
  }

  if (isLoading)
    return (<h1><em>Loading HMA's...</em></h1>);
  if (error)
    return (<h2>Problem loading HMA's: {error}</h2>);
  if (data) {
    return (
      <div>
        <ImageInfo pageId={1} />{/*TODO: this page id is not a mistake. The banner image was never added to hmas page, so must hack it using another page id.*/}
        <PageInfo pageId={3} />
        <div className="row">
          <div className="col-sm-12">
            <div className="dataContainer">
              <div className="row">
                {data.map((item) => (
                  <HMA key={item.id} data={item} selectedItemData={selectedItemData} onSelect={onSelect} />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 text-start">
            <Link className="btn blm-btn-primary"
              to={{ pathname: "/" }} >
              <FontAwesomeIcon icon={["fa", "angle-double-left"]} /> Previous
            </Link>
          </div>
          <div className="col-sm-6 text-end">
            <Link className={`btn blm-btn-primary ${selectedItemData.length > 0 ? "" : "disabled"}`}
              to={{ pathname: "/Donate", state: { selectedItemData: selectedItemData } }} >
              Next <FontAwesomeIcon icon={["fa", "angle-double-right"]} />
            </Link>
          </div>
        </div>
      </div>
    );
  }
  return (<p>No data yet</p>);
}

HMAs.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      selectedItemData: PropTypes.array,
    })
  }),
};